import { render } from "./AnnualPermitModal.vue?vue&type=template&id=fc5874b8&scoped=true"
import script from "./AnnualPermitModal.vue?vue&type=script&lang=js"
export * from "./AnnualPermitModal.vue?vue&type=script&lang=js"

import "./AnnualPermitModal.vue?vue&type=style&index=0&id=fc5874b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc5874b8"]])

export default __exports__